<template>

  <div>

    <!-- modal for edit -->
    <div class="modal modal-primary fade" id="modal-edit">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.adminpanel.tablets.edit')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>{{$t('pages.adminpanel.tablets.name')}}</label>
              <input :value="deviceName" @input="updateDeviceName" @keyup.enter="editDevice(id)" type="text" id="nedit" placeholder="*" class="form-control">
            </div>
            <div class="form-group">
              <label>{{$t('pages.adminpanel.tablets.comment')}}</label>
              <input :value="deviceComment" @input="updateDeviceComment" @keyup.enter="editDevice(id)" type="text" id="cedit" placeholder="*" class="form-control">
            </div>
            <!-- <div class="form-group">
              <label>{{$t('pages.adminpanel.tablets.group')}}</label>
              <input :value="deviceGroup" @input="updateDeviceGroup" @keyup.enter="editDevice(id)" type="text" id="" placeholder="*" class="form-control">
            </div> -->
            <div class="form-group">
              <label>{{$t('pages.adminpanel.tablets.group')}}</label>
              <v-select taggable v-model="selectedGroup" :options="groups" placeholder="*" @search:focus="getGroups" ></v-select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.adminpanel.tablets.modalApproveNoEdit')}}</button>
            <button type="button" class="btn btn-outline" @click.prevent="editDevice(id)">{{$t('pages.adminpanel.tablets.modalApproveYesEdit')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- end modal -->
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">{{$t('pages.adminpanel.tablets.listOfAllDevices')}}</h3>

        <div class="box-tools">
          <div class="input-group input-group-sm" style="width: 150px;">
            <input type="text" name="table_search" class="form-control pull-right" :placeholder="$t('pages.adminpanel.tablets.search')" v-model="searchallDevices">

            <div class="input-group-btn">
              <button type="search" @click.prevent="getAllDevices(searchallDevices)" class="btn btn-default">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body table-responsive no-padding">
        <table class="table table-hover">
          <tbody>
            <tr>
              <th>{{$t('pages.adminpanel.tablets.identifier')}}
                <span v-if="sortByAll == 'identifier'">
                  <a v-if="sortOrderAll == 'desc'" @click.prevent="ca('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrderAll == 'asc'" @click.prevent="ca('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="ca('sortBy','identifier'); ca('sortOrder',sortOrderAfterInitialClickAll)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t('pages.adminpanel.tablets.deviceName')}}
                <span v-if="sortByAll == 'name'">
                  <a v-if="sortOrderAll == 'desc'" @click.prevent="ca('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrderAll == 'asc'" @click.prevent="ca('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="ca('sortBy','name'); ca('sortOrder', sortOrderAfterInitialClickAll)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <!-- <th>{{$t('pages.adminpanel.tablets.created')}} <span v-if="sortByAll == 'createdAt'"><a v-if="sortOrderAll == 'desc'" @click.prevent="ca('sortOrder','asc')"><i class="fa fa-sort-down"></i></a><a v-if="sortOrderAll == 'asc'" @click.prevent="ca('sortOrder','desc')"><i class="fa fa-sort-up"></i></a></span><span v-else><a @click.prevent="ca('sortBy','createdAt'); ca('sortOrder', sortOrderAfterInitialClickAll)"><i class="fa fa-unsorted"></i></a></span></th> -->
              <th>{{$t('pages.adminpanel.tablets.updated')}}
                <span v-if="sortByAll == 'updatedAt'">
                  <a v-if="sortOrderAll == 'desc'" @click.prevent="ca('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrderAll == 'asc'" @click.prevent="ca('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="ca('sortBy','updatedAt'); ca('sortOrder', sortOrderAfterInitialClickAll)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t('pages.adminpanel.tablets.group')}}
                <span v-if="sortByAll == 'group'">
                  <a v-if="sortOrderAll == 'desc'" @click.prevent="ca('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrderAll == 'asc'" @click.prevent="ca('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="ca('sortBy','group'); ca('sortOrder', sortOrderAfterInitialClickAll)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t('pages.adminpanel.tablets.comment')}} </th>
              <th>{{$t('pages.adminpanel.tablets.registered')}}
                <span v-if="sortByAll == 'registered'">
                  <a v-if="sortOrderAll == 'desc'" @click.prevent="ca('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrderAll == 'asc'" @click.prevent="ca('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="ca('sortBy','registered'); ca('sortOrder', sortOrderAfterInitialClickAll)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
            </tr>

            <tr v-for="dev in allDevices">
              <td>{{dev.identifier}}</td>
              <td>
                <a id="buttonPoiner" @click.prevent="toggleModalForEdit(dev)">{{dev.name}}</a>
              </td>
              <!-- <td>{{dev.createdAt}}</td> -->
              <td>
                {{getDate(dev.updatedAt)}}
              </td>

              <td>{{dev.group}}</td>
              <td>{{dev.comment}}</td>
              <td>
                <span v-if="dev.isRegistered">
                  <div class="badge bg-blue">{{$t('pages.adminpanel.tablets.registered')}}</div>
                </span>
              </td>
              <td>
                <button @click.prevent="alertForUpdateSecret(dev)" class="btn btn-primary">{{$t('pages.adminpanel.tablets.generateOtp')}}
                </button>
                <a id="buttonPoiner" class="btn btn-danger" @click.prevent="toggleModalForDeletion(dev)">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <br>
    <!-- other box -->
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">{{$t('pages.adminpanel.tablets.listOfAnnouncedDevices')}}</h3>

        <div class="box-tools">

          <div class="input-group input-group-sm" style="width: 150px;">
            <input type="text" name="table_search" class="form-control pull-right" :placeholder="$t('pages.adminpanel.tablets.search')" v-model="searchannouncedDevices">

            <div class="input-group-btn">
              <button type="search" @click.prevent="getAnnDevices(searchannouncedDevices)" class="btn btn-default">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body table-responsive no-padding">
        <table class="table table-hover">
          <tbody>
            <tr>
              <th>{{$t('pages.adminpanel.tablets.identifier')}}
                <span v-if="sortBy == 'identifier'">
                  <a v-if="sortOrder == 'desc'" @click.prevent="cm('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrder == 'asc'" @click.prevent="cm('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="cm('sortBy','identifier'); cm('sortOrder',sortOrderAfterInitialClick)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <th>{{$t('pages.adminpanel.tablets.deviceName')}}
                <span v-if="sortBy == 'name'">
                  <a v-if="sortOrder == 'desc'" @click.prevent="cm('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrder == 'asc'" @click.prevent="cm('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="cm('sortBy','name'); cm('sortOrder', sortOrderAfterInitialClick)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
              <!-- <th>{{$t('pages.adminpanel.tablets.created')}} <span v-if="sortBy == 'createdAt'"><a v-if="sortOrder == 'desc'" @click.prevent="cm('sortOrder','asc')"><i class="fa fa-sort-down"></i></a><a v-if="sortOrder == 'asc'" @click.prevent="cm('sortOrder','desc')"><i class="fa fa-sort-up"></i></a></span><span v-else><a @click.prevent="cm('sortBy','createdAt'); cm('sortOrder', sortOrderAfterInitialClick)"><i class="fa fa-unsorted"></i></a></span></th> -->
              <th>{{$t('pages.adminpanel.tablets.updated')}}
                <span v-if="sortBy == 'updatedAt'">
                  <a v-if="sortOrder == 'desc'" @click.prevent="cm('sortOrder','asc')">
                    <i class="fa fa-sort-down"></i>
                  </a>
                  <a v-if="sortOrder == 'asc'" @click.prevent="cm('sortOrder','desc')">
                    <i class="fa fa-sort-up"></i>
                  </a>
                </span>
                <span v-else>
                  <a @click.prevent="cm('sortBy','updatedAt'); cm('sortOrder', sortOrderAfterInitialClick)">
                    <i class="fa fa-unsorted"></i>
                  </a>
                </span>
              </th>
            </tr>

            <tr v-for="dev in announcedDevices">
              <td>{{dev.identifier}}</td>
              <td>{{dev.name}}</td>
              <!-- <td>{{dev.createdAt}}</td> -->
              <td>
                {{getDate(dev.updatedAt)}}
              </td>
              <td>
                <button @click.prevent="toggleModalForRegistration(dev)" class="btn btn-primary">{{$t('pages.adminpanel.tablets.register')}}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <!-- end box -->
    <!-- modal for wrench-->
    <div class="modal modal-primary fade" id="modal-register">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.adminpanel.tablets.register')}}</h4>
          </div>
          <div class="modal-body">
            <div v-if="!confirm" class="form-group">
              <label>{{$t('pages.adminpanel.tablets.name')}}</label>
              <input :value="deviceName" @input="updateDeviceName" type="text" id="nreg" placeholder="*" class="form-control">
            </div>
            <div v-if="!confirm" class="form-group">
              <label>{{$t('pages.adminpanel.tablets.comment')}}</label>
              <input :value="deviceComment" @input="updateDeviceComment" type="text" id="creg" placeholder="*" class="form-control">
            </div>
            <!-- <div v-if="!confirm" class="form-group">
              <label>{{$t('pages.adminpanel.tablets.group')}}</label>
              <input :value="deviceGroup" @input="updateDeviceGroup" type="text" id="" placeholder="*" class="form-control">
            </div> -->
            <div v-if="!confirm" class="form-group">
              <label>{{$t('pages.adminpanel.tablets.group')}}</label>
              <v-select taggable v-model="selectedGroup" :options="groups" placeholder="*" @search:focus="getGroups" ></v-select>
            </div>
            <div v-if="confirm" class="form-group">
              <label>{{$t('pages.adminpanel.tablets.password')}}</label>
              <input @keyup.esc="dismissModalForRegistration()" @keyup.enter="approveDevice(identifier)" :value="devicePassword" @input="updateDevicePassword" type="password" id="" placeholder="Please enter your user password" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="confirm" type="button" class="btn btn-outline pull-left" @click.prevent="confirmToggle()">Back</button>
            <button v-else type="button" class="btn btn-outline pull-left" @click.prevent="modalToggle()">{{$t('pages.adminpanel.tablets.modalApproveNo')}}</button>
            <button v-if="!confirm && deviceComment && selectedGroup" type="button" class="btn btn-outline" @click.prevent="confirmToggle()">Continue</button>
            <button v-else-if="confirm" type="button" class="btn btn-outline" @click.prevent="approveDevice(identifier)">{{$t('pages.adminpanel.tablets.modalApproveYes')}}</button>
            <button v-else type="button" class="btn btn-outline disabled">Continue</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- end modal -->
    <div class="modal modal-danger fade" id="modal-delete">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.adminpanel.tablets.delete')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>{{$t('pages.adminpanel.tablets.password')}}</label>
              <input @keyup.enter="deleteDevice(id)" :value="devicePassword" @input="updateDevicePassword" type="password" id="" placeholder="Please enter your user password" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.adminpanel.tablets.modalApproveNo')}}</button>
            <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="deleteDevice(id)">{{$t('pages.adminpanel.tablets.modalDeleteYes')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- modal update secret -->
    <div class="modal modal-primary fade" id="modal-update">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.adminpanel.tablets.generateOtp')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>{{$t('pages.adminpanel.tablets.password')}}</label>
              <input @keyup.enter="generateDevice(id)" :value="devicePassword" @input="updateDevicePassword" type="password" id="pdel" placeholder="Please enter your user password" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.adminpanel.tablets.modalApproveNo')}}</button>
            <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="generateDevice(id)">{{$t('pages.adminpanel.tablets.modalDeleteYes')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- -->
  </div>

</template>

<script>
  // import Vue from 'vue'
  import { mapState } from 'vuex'
  import Rest from './../../services/rest'
  import vSelect from 'vue-select'
  let moment = require('moment')
  export default {
    data () {
      return {
        searchannouncedDevices: '',
        searchallDevices: '',
        confirm: false,
        groups: [],
        selectedGroup: ''
      }
    },
    computed: {
      ...mapState({
        announcedDevices: state => state.exam.announcedDevices, // start announced
        sortOrderAfterInitialClick: state => state.exam.announcedTableState.sortOrderAfterInitialClick,
        sortBy: state => state.exam.announcedTableState.sortBy,
        sortOrder: state => state.exam.announcedTableState.sortOrder,
        limit: state => state.exam.announcedTableState.limit,
        ats: state => state.exam.announcedTableState.announcedTableState,
        identifier: state => state.exam.mutationDevice.identifier,
        deviceName: state => state.exam.mutationDevice.name,
        deviceGroup: state => state.exam.mutationDevice.group,
        deviceComment: state => state.exam.mutationDevice.comment,
        devicePassword: state => state.exam.mutationDevice.password, // end announced
        allDevices: state => state.exam.allDevices,
        sortOrderAfterInitialClickAll: state => state.exam.tableStateAll.sortOrderAfterInitialClick,
        sortByAll: state => state.exam.tableStateAll.sortBy,
        sortOrderAll: state => state.exam.tableStateAll.sortOrder,
        limitAll: state => state.exam.tableStateAll.limit,
        id: state => state.exam.mutationDevice.id
      })
    },
    methods: {
      cm (key, value) { // announced
        this.$store.commit('updateAnnouncedTableState', {
          key: key,
          value: value
        })
        this.getAnnDevices(this.searchannouncedDevices)
      },
      ca (key, value) { // all
        this.$store.commit('updateTableStateAll', {
          key: key,
          value: value
        })
        this.getAllDevices(this.searchallDevices)
      },
      getDate (ct) {
        // return moment(ct).format('MM/DD/YYYY HH:mm')
        return moment(ct).fromNow()
      },
      updateDeviceName (e) {
        this.$store.commit('updateDeviceName', e.target.value)
      },
      updateDeviceGroup (e) {
        this.$store.commit('updateDeviceGroup', e.target.value)
      },
      updateDeviceComment (e) {
        this.$store.commit('updateDeviceComment', e.target.value)
      },
      updateDevicePassword (e) {
        this.$store.commit('updateDevicePassword', e.target.value)
      },
      approveDevice (identifier) {
        this.$store.commit('updateDeviceGroup', this.selectedGroup)
        this.$store.dispatch('approveDevice', identifier).then(() => {
          this.getAllDevices()
          this.getAnnDevices()
          window.jQuery('#modal-register').modal('hide')
          this.confirmToggle()
        })
      },
      editDevice (id) {
        this.$store.commit('updateDeviceGroup', this.selectedGroup)
        this.$store.dispatch('editDevice', id).then(() => {
          alert(this.$t('pages.adminpanel.tablets.alertSuccess'))
          this.getAllDevices()
          window.jQuery('#modal-edit').modal('hide')
          this.confirmToggle()
        })
      },
      getAnnDevices (searchQuery) {
        this.$store.dispatch('getAnnounced', searchQuery)
      },
      getAllDevices (searchQuery) {
        this.$store.dispatch('getAllDevices', searchQuery)
      },
      deleteDevice (id) {
        this.$store.dispatch('deleteDevice', id).then((data) => {
          alert(data.message)
          this.getAllDevices()
          window.jQuery('#modal-delete').modal('hide')
        }).catch((err) => {
          alert(err.responseJSON['message'])
        })
      },
      generateDevice (id) {
        this.$store.dispatch('generateDevice', id).then((data) => {
          alert(data.message + '\n' + data.code)
          this.getAllDevices()
          window.jQuery('#modal-update').modal('hide')
        }).catch((err) => {
          alert(err.responseJSON['message'])
        })
      },
      dismissModalForRegistration () {
        window.jQuery('#modal-register').modal('hide')
      },
      toggleModalForRegistration (dev) {
        this.$store.commit('updateDeviceName', 'IT-Charm tablet')
        this.$store.commit('updateDeviceIdentifier', dev.identifier)
        window.jQuery('#modal-register').modal('toggle')
      },
      toggleModalForDeletion (dev) {
        this.$store.commit('updateDeviceId', dev.id)
        window.jQuery('#modal-delete').modal('toggle')
      },
      toggleModalForEdit (dev) {
        this.$store.commit('updateDeviceName', dev.name)
        this.$store.commit('updateDeviceGroup', dev.group)
        this.selectedGroup = dev.group
        this.$store.commit('updateDeviceComment', dev.comment)
        this.$store.commit('updateDeviceId', dev.id)
        window.jQuery('#modal-edit').modal('toggle')
      },
      alertForUpdateSecret (dev) {
        this.$store.commit('updateDeviceId', dev.id)
        window.jQuery('#modal-update').modal('toggle')
      },
      confirmToggle () {
        this.confirm = !this.confirm
      },
      modalToggle () {
        window.jQuery('#modal-register').modal('toggle')
        this.confirm = false
        this.selectedGroup = ''
      },
      getGroups () {
        return Rest.request('GET', '/devices/groups').then((data) => {
          this.groups = data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    subscriptions () {
      return {
        announcedDevicesSearch: this.$watchAsObservable('searchannouncedDevices').map((val) => val.newValue)
        .debounceTime(500)
        .distinctUntilChanged()
        .do({
          next: (searchQ) => {
            this.getAnnDevices(searchQ)
          }
        }),
        allDevicesSearch: this.$watchAsObservable('searchallDevices').map((val) => val.newValue)
        .debounceTime(500)
        .distinctUntilChanged()
        .do({
          next: (searchQ) => {
            this.getAllDevices(searchQ)
          }
        })
      }
    },
    mounted () {
      this.getAnnDevices()
      this.getAllDevices()
      this.getGroups()
    },
    components: {
      'v-select': vSelect
    }
  }
</script>

<style lang="scss">
$black-color: black;
#buttonPoiner:hover {
  cursor: pointer;
}
.povezave {
color: $black-color;
}
.v-select {
  background: #fff;
}
</style>




// WEBPACK FOOTER //
// Tablets.vue?0201d4fb